module.exports = __webpack_public_path__ + "static/media/r217.421800ef.jpg";